import { render, staticRenderFns } from "./PaySlipToolPage.vue?vue&type=template&id=ca74a3dc&scoped=true&"
import script from "./PaySlipToolPage.vue?vue&type=script&lang=js&"
export * from "./PaySlipToolPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca74a3dc",
  null
  
)

export default component.exports